import { DEFAULT_GROUPS_SORT_BY } from "@components/groups/groups-constants";
import { getGroupsSortBy } from "@utils/group-utils";
import { isGroupsSortField } from "@custom-types/type-guards";
import { convertGridSortModelToSortBy } from "@utils/sort-utils";

/**
 * @returns a valid groups `sortBy` option from the passed GridSortModel
 * @param gridSortModel Groups table sort model
 */
export function getSortByFromGridSortModel(gridSortModel) {
  return convertGridSortModelToSortBy(gridSortModel, {
    defaultSortBy: DEFAULT_GROUPS_SORT_BY,
    isValidSortField: isGroupsSortField,
    getSortBy: getGroupsSortBy
  });
}